import { ActionReducer, Action } from '@ngrx/store';
import { BookingInitState } from '../models/booking-reducer.interface';
import { UPDATE_MANUAL_DESTINATION } from './flight.reducer';

export const UPDATE_BOOKING_TYPE = 'UPDATE_BOOKING_TYPE';
export const UPDATE_BOOKING_FLIGHT_DATE_AMEND = 'UPDATE_BOOKING_FLIGHT_DATE_AMEND';
export const UPDATE_BOOKING_PRODUCT = 'UPDATE_BOOKING_PRODUCT';
export const UPDATE_BOOKING_PAID = 'UPDATE_BOOKING_PAID';
export const UPDATE_BOOKING_REQUIRES_PAYMENT = 'UPDATE_BOOKING_REQUIRES_PAYMENT';
export const UPDATE_IS_AIRPORT_TO_AIRPORT = 'UPDATE_IS_AIRPORT_TO_AIRPORT';
export const UPDATE_JOURNEY_LEG = 'UPDATE_JOURNEY_LEG';
export const UPDATE_CARRIER = 'UPDATE_CARRIER';
export const UPDATE_BOOKING_REFERENCE = 'UPDATE_BOOKING_REFERENCE';
export const UPDATE_BOOKING_JOURNEY_REFERENCE = 'UPDATE_BOOKING_JOURNEY_REFERENCE';
export const UPDATE_BOOKING_AMEND_SECTION = 'UPDATE_BOOKING_AMEND_SECTION';
export const UPDATE_BOOKING_AMEND_TYPE = 'UPDATE_BOOKING_AMEND_TYPE';
export const UPDATE_BOOKING_SOURCE = 'UPDATE_BOOKING_SOURCE';
export const UPDATE_BOOKING_TIME_AMENDED = 'UPDATE_BOOKING_TIME_AMENDED';
export const UPDATE_BOOKING_AMEND_PAID_INVOICE = 'UPDATE_BOOKING_AMEND_PAID_INVOICE';
export const UPDATE_BOOKING_AMEND_PAYMENT_FAILED = 'UPDATE_BOOKING_AMEND_PAYMENT_FAILED';
export const UPDATE_BOOKING_ID = 'UPDATE_BOOKING_ID';
export const UPDATE_VIRTUAL_BAGS = 'UPDATE_VIRTUAL_BAGS';
export const UPDATE_BAG_ITEMS = 'UPDATE_BAG_ITEMS';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';
export const UPDATE_PREMIUM_SURCHARGE = 'UPDATE_PREMIUM_SURCHARGE';
export const UPDATE_PLACE_ID = 'UPDATE_PLACE_ID';
export const UPDATE_CUSTOMER_ADDRESS = 'UPDATE_CUSTOMER_ADDRESS';
export const UPDATE_CUSTOMER_DETAILS = 'UPDATE_CUSTOMER_DETAILS';
export const UPDATE_CUSTOMER_HAS_MARKETING_ENROLMENT = 'UPDATE_CUSTOMER_HAS_MARKETING_ENROLMENT';
export const UPDATE_OPTED_IN_VIA_BANNER = 'UPDATE_OPTED_IN_VIA_BANNER';
export const UPDATE_CUSTOMER_RETURN_URL = 'UPDATE_CUSTOMER_RETURN_URL';
export const UPDATE_PNR_DATA = 'UPDATE_PNR_DATA';
export const UPDATE_TIMESLOT = 'UPDATE_TIMESLOT';
export const UPDATE_AIRPORT_TIMESLOT = 'UPDATE_AIRPORT_TIMESLOT';
export const UPDATE_PROMO = 'UPDATE_PROMO';
export const REMOVE_PROMO = 'REMOVE_PROMO';
export const UPDATE_QUOTE_PRICE_REQUEST = 'UPDATE_QUOTE_PRICE_REQUEST';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const UPDATE_AB_TEST_QUOTE = 'UPDATE_AB_TEST_QUOTE';
export const UPDATE_AB_TEST_FORM = 'UPDATE_AB_TEST_FORM';
export const UPDATE_ADD_BOOKING_CALLED = 'UPDATE_ADD_BOOKING_CALLED';
export const REFRESH_BOOKING_STATE = 'REFRESH_BOOKING_STATE';
export const RESET_BOOKING_STATE = 'RESET_BOOKING_STATE';
export const HAS_CUSTOMS_AGREEMENT = 'HAS_CUSTOMS_AGREEMENT';
export const ZONE_INFO_UPDATE = 'ZONE_INFO_UPDATE';
export const UPDATE_D2D_SERVICE = 'UPDATE_D2D_SERVICE';
export const UPDATE_AUTO_REFRESH_TIME_SERVICE = 'UPDATE_AUTO_REFRESH_TIME_SERVICE';
export const SAVE_SELECTED_TIMESLOT_DATE_TIME = 'SAVE_SELECTED_TIMESLOT_DATE_TIME';
export const SAVE_UUID = 'SAVE_UUID';
export const UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS = 'UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS';
export const UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS = 'UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS';
export const UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS = 'UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS';
export const UPDATE_SBB_DB_TYPE = 'UPDATE_SBB_DB_TYPE';
export const UPDATE_SBB_DB_AMOUNT = 'UPDATE_SBB_DB_AMOUNT';
export const UPDATE_CAT_DISCOUNT_STATUS = 'UPDATE_CAT_DISCOUNT_STATUS';
export const CAT_DISCOUNT_AVAILABLE_UPDATE = 'CAT_DISCOUNT_AVAILABLE_UPDATE';
export const UPDATE_ADDRESS_MANUAL_INPUT = 'UPDATE_ADDRESS_MANUAL_INPUT';
export const SBB_SUBSIDY_STATUS_UPDATE = 'SBB_SUBSIDY_STATUS_UPDATE';
export const SBB_SUBSIDY_DB_STATUS_UPDATE = 'SBB_SUBSIDY_DB_STATUS_UPDATE';
export const BOOKER_DATA_BACKUP = 'BOOKER_DATA_BACKUP';
export const UPDATE_UNIQUE_SEQUENCE_ID = 'UPDATE_UNIQUE_SEQUENCE_ID';
export const UPDATE_BOOKING_REFERENCE_STATE = 'UPDATE_BOOKING_REFERENCE_STATE';
export const UPDATE_RESERVED_TIMESLOT = 'UPDATE_RESERVED_TIMESLOT';
export const UPDATE_ORIGNAL_BOOKING_AMEND_TYPE = 'UPDATE_ORIGNAL_BOOKING_AMEND_TYPE';
export const RESET_BOOKING_REFERENCE_STATE = 'RESET_BOOKING_REFERENCE_STATE';
export const SET_LOGIN_TYPE = 'SET_LOGIN_TYPE';
export const SHOW_OVERSIZE_PROMO_TOAST = 'SHOW_OVERSIZE_PROMO_TOAST';
export const UPDATE_CUTOFF_DATETIME = 'UPDATE_CUTOFF_DATETIME';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: BookingInitState = {
  bookingDetails: {
    isSbbSubsidyApplied: true,
    isSbbSubsidyAvailable: false,
    isDbSubsidyApplicable: false,
    isDbSubsidyApplied: false,
    isLhSubsidyApplied: false,
    dbSubsidyType: null,
    dbSubsidyAmount: 0,
    isCatDiscountApplied: false,
    isCatDiscountAvailable: false,
    bookerDataBackup: null,
    bookingType: 'new',
    bookingFlightDateAmend: false,
    bookingProduct: 'abc',
    isD2dService: false,
    autoRefreshTime: '',
    bookingSource: null,
    bookingReference: '',
    bookingReferenceState: {
      hubdropBookingReference: null,
      simpleBookingReference: null,
    },
    bookingJourneyReference: '',
    bookingAmendSection: '',
    bookingAmendType: 'none',
    orignalAmendType: '',
    bookingJourneyTimeAmended: false,
    bookingAmendPaidByInvoice: false,
    bookingAmendPaymentFailed: false,
    bookingRequiresPayment: false,
    bookingPaid: false,
    hasCustomsAgreement: false,
    carrier: {
      originalAirlineCode: '',
      airlineCodeDisplayName: '',
      airlineCode: '',
      airlineName: '',
      operatingCode: '',
      operatingName: ''
    },
    isAirportToAirport: false,
    journeyLegDetails: [],
    journeyIncompleteId: '',
    timeslot: {
      start: '',
      end: '',
      date: '',
      id: '',
      overrideTimeSlotCapacity: false,
      airportTimeslotsWarning: false
    },
    airportTimeslot: {
      start: '',
      end: '',
      date: ''
    },
    placeId: '',
    customerAddress: {
      addressLine1: '',
      addressLine2: '',
      addressPostCode: '',
      addressTown: '',
      geoCoord: {
        latitude: '',
        longitude: ''
      }
    },
    customerDetails: {
      firstName: '',
      lastName: '',
      emailAddress: ''
    },
    customerHasMarketingEnrolment: false,
    optedInViaBanner: false,
    customerReturnUrl: '',
    pnrData: {
      showPNRField: false,
      isPNRStored: false
    },
    totalPrice: '',
    premiumSurcharge: {
      charge: '',
      hasApplied: false
    },
    promo: [],
    quotePriceRequest: {},
    quote: {
      hasData: false,
      sessionId: null,
      data: [],
      flightData: {}
    },
    addBookingCalled: false,
    virtualBagCount: 0,
    bagItems: {
      bags: 1,
      childEquipment: 0,
      oversizeItem: 0
    },
    abTestingDataQuote: {
      bookingPodEnv: null,
      bookingPodVersion: null
    },
    abTestingDataForm: {
      bookingFormEnv: null,
      bookingFormVersion: null
    },
    zoneInfo: {
      zoneId: '',
      zoneDescription: ''
    },
    selectedTimeslotDateTime: '',
    uuid: '',
    reservedTimeslotId: '',
    loginType: '',
    showOverSizePromoToast: true,
    partnerAirlineCode: '',
    cutOffDateTime: '',
    graceEndDateTime: '',
  }
};

export function bookingReducer(state: BookingInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {

    case UPDATE_JOURNEY_LEG:
      return Object.assign({}, state, {
        bookingDetails: Object.assign({}, state.bookingDetails,
          { journeyLegDetails: [action.payload] }
        )
      });

    case UPDATE_BOOKING_TYPE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingType: action.payload }) });

      case UPDATE_BOOKING_FLIGHT_DATE_AMEND:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingFlightDateAmend: action.payload }) });

    case UPDATE_BOOKING_PRODUCT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingProduct: action.payload }) });

    case UPDATE_D2D_SERVICE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isD2dService: action.payload }) });

    case UPDATE_AUTO_REFRESH_TIME_SERVICE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { autoRefreshTime: action.payload }) });

    case UPDATE_CARRIER:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { carrier: action.payload }) });

    case UPDATE_BOOKING_REFERENCE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingReference: action.payload }) });

    case UPDATE_BOOKING_JOURNEY_REFERENCE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingJourneyReference: action.payload }) });

    case UPDATE_UNIQUE_SEQUENCE_ID:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { uniqueSequenceIdentifier: action.payload }) });

    case UPDATE_BOOKING_AMEND_SECTION:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingAmendSection: action.payload }) });

    case UPDATE_BOOKING_AMEND_TYPE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingAmendType: action.payload }) });

    case UPDATE_ORIGNAL_BOOKING_AMEND_TYPE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { orignalAmendType: action.payload }) });

    case UPDATE_BOOKING_SOURCE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingSource: action.payload }) });

    case UPDATE_BOOKING_TIME_AMENDED:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingJourneyTimeAmended: action.payload }) });

    case UPDATE_BOOKING_AMEND_PAID_INVOICE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingAmendPaidByInvoice: action.payload }) });

    case UPDATE_BOOKING_AMEND_PAYMENT_FAILED:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingAmendPaymentFailed: action.payload }) });

    case UPDATE_BOOKING_PAID:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingPaid: action.payload }) });

    case UPDATE_BOOKING_REQUIRES_PAYMENT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingRequiresPayment: action.payload }) });

    case UPDATE_IS_AIRPORT_TO_AIRPORT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isAirportToAirport: action.payload }) });

    case UPDATE_BOOKING_ID:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { journeyIncompleteId: action.payload }) });

    case UPDATE_VIRTUAL_BAGS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { virtualBagCount: parseInt(action.payload, 10) }) });

    case UPDATE_BAG_ITEMS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bagItems: action.payload }) });

    case UPDATE_TOTAL_PRICE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { totalPrice: action.payload }) });

    case UPDATE_PREMIUM_SURCHARGE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { premiumSurcharge: action.payload }) });

    case UPDATE_TIMESLOT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { timeslot: action.payload }) });

    case UPDATE_AIRPORT_TIMESLOT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { airportTimeslot: action.payload }) });

    case UPDATE_PLACE_ID:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { placeId: action.payload }) });

    case UPDATE_CUSTOMER_ADDRESS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { customerAddress: action.payload }) });

    case UPDATE_CUSTOMER_DETAILS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { customerDetails: action.payload }) });

    case UPDATE_CUSTOMER_HAS_MARKETING_ENROLMENT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { customerHasMarketingEnrolment: action.payload }) });

    case UPDATE_OPTED_IN_VIA_BANNER:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { optedInViaBanner: action.payload }) });

    case UPDATE_CUSTOMER_RETURN_URL:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { customerReturnUrl: action.payload }) });

    case UPDATE_PNR_DATA:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { pnrData: action.payload }) });

    case UPDATE_PROMO:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { promo: [action.payload] }) });

    case REMOVE_PROMO:
      return Object.assign({}, state, {
        bookingDetails: Object.assign({}, state.bookingDetails,
          { promo: action.payload }
        )
      });

    case UPDATE_QUOTE_PRICE_REQUEST:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { quotePriceRequest: action.payload }) });

    case UPDATE_QUOTE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { quote: action.payload }) });

    case UPDATE_AB_TEST_QUOTE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { abTestingDataQuote: action.payload }) });

    case UPDATE_AB_TEST_FORM:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { abTestingDataForm: action.payload }) });

    case UPDATE_ADD_BOOKING_CALLED:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { addBookingCalled: action.payload }) });

    case REFRESH_BOOKING_STATE:
      state = Object.assign({}, action.payload);
      return state;

    case RESET_BOOKING_STATE:
      state = Object.assign({}, initState);
      return state;

    case HAS_CUSTOMS_AGREEMENT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { hasCustomsAgreement: action.payload})});

    case ZONE_INFO_UPDATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { zoneInfo: action.payload }) });

    case SAVE_SELECTED_TIMESLOT_DATE_TIME:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { selectedTimeslotDateTime: action.payload }) });

    case SAVE_UUID:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { uuid: action.payload }) });

    case UPDATE_SBB_PUBLIC_TRANSPORT_DISCOUNT_STATUS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isSbbSubsidyApplied: action.payload }) });

    case UPDATE_SBB_PUBLIC_TRANSPORT_DB_DISCOUNT_STATUS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isDbSubsidyApplied : action.payload }) });

    case UPDATE_SBB_PUBLIC_TRANSPORT_LH_DISCOUNT_STATUS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isLhSubsidyApplied : action.payload }) });

    case UPDATE_SBB_DB_TYPE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { dbSubsidyType : action.payload }) });

    case UPDATE_SBB_DB_AMOUNT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { dbSubsidyAmount : action.payload }) });

    case SBB_SUBSIDY_DB_STATUS_UPDATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isDbSubsidyApplicable: action.payload }) });

    case SBB_SUBSIDY_STATUS_UPDATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isSbbSubsidyAvailable: action.payload }) });

    case UPDATE_CAT_DISCOUNT_STATUS:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isCatDiscountApplied: action.payload }) });

    case CAT_DISCOUNT_AVAILABLE_UPDATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { isCatDiscountAvailable: action.payload }) });

    case UPDATE_RESERVED_TIMESLOT:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { reservedTimeslotId: action.payload }) });

    case UPDATE_BOOKING_REFERENCE_STATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingReferenceState: action.payload }) });

    case RESET_BOOKING_REFERENCE_STATE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookingReferenceState: { hubdropBookingReference: null, simpleBookingReference: null, } }) });

    case BOOKER_DATA_BACKUP:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { bookerDataBackup: action.payload }) });

    case SET_LOGIN_TYPE:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { loginType: action.payload }) });

    case SHOW_OVERSIZE_PROMO_TOAST:
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { showOverSizePromoToast: action.payload }) });

    case 'UPDATE_PARTNER_AIRLINE_CODE':
      return Object.assign({}, state, { bookingDetails: Object.assign({}, state.bookingDetails, { partnerAirlineCode: action.payload }) });

    case UPDATE_CUTOFF_DATETIME:
      return Object.assign({}, state, {
        bookingDetails: Object.assign({}, state.bookingDetails, {
          cutOffDateTime: action.payload.cutOffDateTime,
          graceEndDateTime: action.payload.graceEndDateTime
        })
      });

    default:
      return state;
  }

};
